import LedgerActionTypes from './ledger-types'

export const startFetchLedgerCurrenciesId = data => ({
    type: LedgerActionTypes.START_FETCH_CURRENCIES_ID,
    payload: data,
})
export const successFetchLedgerCurrenciesId = data => ({
    type: LedgerActionTypes.SUCCESS_FETCH_CURRENCIES_ID,
    payload: data,
})
export const fetchUserBankAccountsId = data => ({
    type: LedgerActionTypes.START_USER_BANK_ACCOUNTS_ID,
    payload: data,
})

export const successUserBankAccountsId = data => ({
    type: LedgerActionTypes.SUCCESS_USER_BANK_ACCOUNTS_ID,
    payload: data,
})

export const refreshDashboards = data => ({
    type: LedgerActionTypes.REFRESH_DATA,
    payload: data,
})

export const startCountriesList = data => ({
    type: LedgerActionTypes.START_COUNTRIES_LIST,
    payload: data,
})

export const successCountriesList = data => ({
    type: LedgerActionTypes.SUCCESS_COUNTRIES_LIST,
    payload: data,
})

export const failureCountriesList = data => ({
    type: LedgerActionTypes.FAILURE_COUNTRIES_LIST,
    payload: data,
})

/***************  Order new currency ****************/

export const startOrderCurrency = data => ({
    type: LedgerActionTypes.START_ORDER_CURRENCY,
    payload: data,
})

export const successOrderCurrency = data => ({
    type: LedgerActionTypes.SUCCESS_ORDER_CURRENCY,
    payload: data,
})

export const finishOrderCurrency = data => ({
    type: LedgerActionTypes.FINISH_ORDER_CURRENCY,
    payload: data,
})

export const failureOrderCurrency = data => ({
    type: LedgerActionTypes.FAILURE_ORDER_CURRENCY,
    payload: data,
})

/***************  Order new Multi currency ****************/

export const startOrderMultiCurrency = data => ({
    type: LedgerActionTypes.START_ORDER_MULTI_CURRENCY,
    payload: data,
})

export const successOrderMultiCurrency = data => ({
    type: LedgerActionTypes.SUCCESS_ORDER_MULTI_CURRENCY,
    payload: data,
})

export const finishOrderMultiCurrency = data => ({
    type: LedgerActionTypes.FINISH_ORDER_MULTI_CURRENCY,
    payload: data,
})

export const failureOrderMultiCurrency = data => ({
    type: LedgerActionTypes.FAILURE_ORDER_MULTI_CURRENCY,
    payload: data,
})

/*****************   Bank Account Order   ********************/

export const startBankAccountOrder = data => ({
    type: LedgerActionTypes.START_BANK_ACCOUNT_ORDER,
    payload: data,
})
export const successBankAccountOrder = data => ({
    type: LedgerActionTypes.SUCCESS_BANK_ACCOUNT_ORDER,
    payload: data,
})
export const finishBankAccountOrder = data => ({
    type: LedgerActionTypes.FINISH_BANK_ACCOUNT_ORDER,
    payload: data,
})
export const failureBankAccountOrder = data => ({
    type: LedgerActionTypes.FAILURE_BANK_ACCOUNT_ORDER,
    payload: data,
})

/*****************   Open Bank Accounts Available   ********************/

export const startOpenBankAccountsAvailable = data => ({
    type: LedgerActionTypes.START_OPEN_BANK_ACCOUNTS_AVAILABLE,
    payload: data,
})

export const successOpenBankAccountsAvailable = data => ({
    type: LedgerActionTypes.SUCCESS_OPEN_BANK_ACCOUNTS_AVAILABLE,
    payload: data,
})

/*******************  Top Up Ledger With Bank Transfer ********************* */

export const startTopUpWithBankTransfer = data => ({
    type: LedgerActionTypes.START_TOP_UP_WITH_BANK_TRANSFER,
    payload: data,
})
export const successTopUpWithBankTransfer = data => ({
    type: LedgerActionTypes.SUCCESS_TOP_UP_WITH_BANK_TRANSFER,
    payload: data,
})
export const finishTopUpWithBankTransfer = data => ({
    type: LedgerActionTypes.FINISH_TOP_UP_WITH_BANK_TRANSFER,
    payload: data,
})
export const failureTopUpWithBankTransfer = data => ({
    type: LedgerActionTypes.FAILURE_TOP_UP_WITH_BANK_TRANSFER,
    payload: data,
})

/*******************  Top Up Ledger With Card V2 ********************* */

export const startLedgerTopUpWithNoCardData = data => ({
    type: LedgerActionTypes.START_LEDGER_TOP_UP_WITH_NO_CARD_DATA,
    payload: data,
})
export const successLedgerTopUpWithNoCardData = data => ({
    type: LedgerActionTypes.SUCCESS_LEDGER_TOP_UP_WITH_NO_CARD_DATA,
    payload: data,
})
export const finishLedgerTopUpWithNoCardData = data => ({
    type: LedgerActionTypes.FINISH_LEDGER_TOP_UP_WITH_NO_CARD_DATA,
    payload: data,
})
export const failureLedgerTopUpWithNoCardData = data => ({
    type: LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_NO_CARD_DATA,
    payload: data,
})

/*******************  Top Up Ledger With Online Bank ********************* */

export const startLedgerTopUpWithOnlineBank = data => ({
    type: LedgerActionTypes.START_LEDGER_TOP_UP_WITH_ONLINE_BANK,
    payload: data,
})
export const successLedgerTopUpWithOnlineBank = data => ({
    type: LedgerActionTypes.SUCCESS_LEDGER_TOP_UP_WITH_ONLINE_BANK,
    payload: data,
})
export const finishLedgerTopUpWithOnlineBank = data => ({
    type: LedgerActionTypes.FINISH_LEDGER_TOP_UP_WITH_ONLINE_BANK,
    payload: data,
})
export const failureLedgerTopUpWithOnlineBank = data => ({
    type: LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_ONLINE_BANK,
    payload: data,
})

/*******************  3D Secure Card ********************* */

export const start3dSecureCard = data => ({
    type: LedgerActionTypes.START_SECURE_3D_CARD,
    payload: data,
})
export const success3dSecureCard = data => ({
    type: LedgerActionTypes.SUCCESS_SECURE_3D_CARD,
    payload: data,
})
export const finish3dSecureCard = data => ({
    type: LedgerActionTypes.FINISH_SECURE_3D_CARD,
    payload: data,
})
export const failure3dSecureCard = data => ({
    type: LedgerActionTypes.FAILURE_SECURE_3D_CARD,
    payload: data,
})

/*******************  3D Secure Online Bank ********************* */

export const start3dSecureOnlineBank = data => ({
    type: LedgerActionTypes.START_SECURE_3D_ONLINE_BANK,
    payload: data,
})
export const success3dSecureOnlineBank = data => ({
    type: LedgerActionTypes.SUCCESS_SECURE_3D_ONLINE_BANK,
    payload: data,
})
export const finish3dSecureOnlineBank = data => ({
    type: LedgerActionTypes.FINISH_SECURE_3D_ONLINE_BANK,
    payload: data,
})
export const failure3dSecureOnlineBank = data => ({
    type: LedgerActionTypes.FAILURE_SECURE_3D_ONLINE_BANK,
    payload: data,
})

/*************************  Internal Bank Transfer ************************** */

export const startBankInternalTransfer = data => ({
    type: LedgerActionTypes.START_BANK_ACCOUNT_INTERNAL_TRANSFER,
    payload: data,
})
export const successBankInternalTransfer = data => ({
    type: LedgerActionTypes.SUCCESS_BANK_ACCOUNT_INTERNAL_TRANSFER,
    payload: data,
})
export const finishBankInternalTransfer = data => ({
    type: LedgerActionTypes.FINISH_BANK_ACCOUNT_INTERNAL_TRANSFER,
    payload: data,
})
export const failureBankInternalTransfer = data => ({
    type: LedgerActionTypes.FAILURE_BANK_ACCOUNT_INTERNAL_TRANSFER,
    payload: data,
})

/*************************  Top up Bank account with ledger currency ************************** */

export const startBankAccountTopUpWithCurrency = data => ({
    type: LedgerActionTypes.START_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY,
    payload: data,
})
export const successBankAccountTopUpWithCurrency = data => ({
    type: LedgerActionTypes.SUCCESS_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY,
    payload: data,
})
export const finishBankAccountTopUpWithCurrency = data => ({
    type: LedgerActionTypes.FINISH_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY,
    payload: data,
})
export const failureBankAccountTopUpWithCurrency = data => ({
    type: LedgerActionTypes.FAILURE_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY,
    payload: data,
})

/*************************  Withdraw Bank account with ledger currency ************************** */

export const startBankAccountWithdrawWithCurrency = data => ({
    type: LedgerActionTypes.START_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY,
    payload: data,
})
export const successBankAccountWithdrawWithCurrency = data => ({
    type: LedgerActionTypes.SUCCESS_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY,
    payload: data,
})
export const finishBankAccountWithdrawWithCurrency = data => ({
    type: LedgerActionTypes.FINISH_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY,
    payload: data,
})
export const failureBankAccountWithdrawWithCurrency = data => ({
    type: LedgerActionTypes.FAILURE_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY,
    payload: data,
})

/*************************  Exchange All Assets Calculator ************************** */

export const startFeeCalculator = data => ({
    type: LedgerActionTypes.START_FEE_CALCULATOR,
    payload: data,
})

export const successFeeCalculator = data => ({
    type: LedgerActionTypes.SUCCESS_FEE_CALCULATOR,
    payload: data,
})

export const finishFeeCalculator = data => ({
    type: LedgerActionTypes.FINISH_FEE_CALCULATOR,
    payload: data,
})

export const failureFeeCalculator = data => ({
    type: LedgerActionTypes.FAILURE_FEE_CALCULATOR,
    payload: data,
})

/*************************  Merged Fees Calculator ************************** */

export const startMergedFeeCalculator = data => ({
    type: LedgerActionTypes.START_MERGED_FEE_CALCULATOR,
    payload: data,
})

export const successMergedFeeCalculator = data => ({
    type: LedgerActionTypes.SUCCESS_MERGED_FEE_CALCULATOR,
    payload: data,
})

export const finishMergedFeeCalculator = data => ({
    type: LedgerActionTypes.FINISH_MERGED_FEE_CALCULATOR,
    payload: data,
})

export const failureMergedFeeCalculator = data => ({
    type: LedgerActionTypes.FAILURE_MERGED_FEE_CALCULATOR,
    payload: data,
})

/*************************  Exchange All Assets ************************** */

export const startExchangeAllAssets = data => ({
    type: LedgerActionTypes.START_EXCHANGE_All_ASSETS,
    payload: data,
})

export const successExchangeAllAssets = data => ({
    type: LedgerActionTypes.SUCCESS_EXCHANGE_All_ASSETS,
    payload: data,
})

export const finishExchangeAllAssets = data => ({
    type: LedgerActionTypes.FINISH_EXCHANGE_All_ASSETS,
    payload: data,
})

export const failureExchangeAllAssets = data => ({
    type: LedgerActionTypes.FAILURE_EXCHANGE_All_ASSETS,
    payload: data,
})

/*************************  Transfer ************************** */

export const startTransfer = data => ({
    type: LedgerActionTypes.START_TRANSFER,
    payload: data,
})

export const successTransfer = data => ({
    type: LedgerActionTypes.SUCCESS_TRANSFER,
    payload: data,
})

export const finishTransfer = data => ({
    type: LedgerActionTypes.FINISH_TRANSFER,
    payload: data,
})

export const failureTransfer = data => ({
    type: LedgerActionTypes.FAILURE_TRANSFER,
    payload: data,
})

/*************************  Transfer to Bank ************************** */

export const startGetMaxAmount = data => ({
    type: LedgerActionTypes.START_GET_MAX_AMOUNT,
    payload: data,
})

export const successGetMaxAmount = data => ({
    type: LedgerActionTypes.SUCCESS_GET_MAX_AMOUNT,
    payload: data,
})

export const failureGetMaxAmount = data => ({
    type: LedgerActionTypes.FAILURE_GET_MAX_AMOUNT,
    payload: data,
})
export const finishGetMaxAmount = data => ({
    type: LedgerActionTypes.FINISH_GET_MAX_AMOUNT,
    payload: data,
})

export const startTransferToBank = data => ({
    type: LedgerActionTypes.START_TRANSFER_TO_BANK,
    payload: data,
})

export const successTransferToBank = data => ({
    type: LedgerActionTypes.SUCCESS_TRANSFER_TO_BANK,
    payload: data,
})

export const finishTransferToBank = data => ({
    type: LedgerActionTypes.FINISH_TRANSFER_TO_BANK,
    payload: data,
})

export const failureTransferToBank = data => ({
    type: LedgerActionTypes.FAILURE_TRANSFER_TO_BANK,
    payload: data,
})

/*************************  Transfer from iban to Bank ************************** */

export const startTransferFromIbanToBank = data => ({
    type: LedgerActionTypes.START_TRANSFER_FROM_IBAN_TO_BANK,
    payload: data,
})

export const successTransferFromIbanToBank = data => ({
    type: LedgerActionTypes.SUCCESS_TRANSFER_FROM_IBAN_TO_BANK,
    payload: data,
})

export const finishTransferFromIbanToBank = data => ({
    type: LedgerActionTypes.FINISH_TRANSFER_FROM_IBAN_TO_BANK,
    payload: data,
})

export const failureTransferFromIbanToBank = data => ({
    type: LedgerActionTypes.FAILURE_TRANSFER_FROM_IBAN_TO_BANK,
    payload: data,
})

/************************ Pay Now ************************** */

export const startPayNow = data => ({
    type: LedgerActionTypes.START_PAY_NOW,
    payload: data,
})
export const successPayNow = data => ({
    type: LedgerActionTypes.SUCCESS_PAY_NOW,
    payload: data,
})
export const finishPayNow = data => ({
    type: LedgerActionTypes.FINISH_PAY_NOW,
    payload: data,
})
export const failurePayNow = data => ({
    type: LedgerActionTypes.FAILURE_PAY_NOW,
    payload: data,
})

/************************ Banks BIC ************************** */

export const startBankBic = data => ({
    type: LedgerActionTypes.START_BANK_BIC,
    payload: data,
})
export const successBankBic = data => ({
    type: LedgerActionTypes.SUCCESS_BANK_BIC,
    payload: data,
})
export const finishBankBic = data => ({
    type: LedgerActionTypes.FINISH_BANK_BIC,
    payload: data,
})
export const failureBankBic = data => ({
    type: LedgerActionTypes.FAILURE_BANK_BIC,
    payload: data,
})

/************************ Company Payment by Card ************************** */

export const startCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.START_COMPANY_PAYMENT_CARD,
    payload: data,
})
export const successCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.SUCCESS_COMPANY_PAYMENT_CARD,
    payload: data,
})
export const finishCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.FINISH_COMPANY_PAYMENT_CARD,
    payload: data,
})
export const failureCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.FAILURE_COMPANY_PAYMENT_CARD,
    payload: data,
})

/*******************  3D Secure Card Payment ********************* */

export const start3dSecureCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.START_SECURE_3D_COMPANY_CARD_PAYMENT,
    payload: data,
})
export const success3dSecureCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.SUCCESS_SECURE_3D_COMPANY_CARD_PAYMENT,
    payload: data,
})
export const finish3dSecureCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.FINISH_SECURE_3D_COMPANY_CARD_PAYMENT,
    payload: data,
})
export const failure3dSecureCompanyPaymentByCard = data => ({
    type: LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_CARD_PAYMENT,
    payload: data,
})

/************************ Company Payment by Online Banking ************************** */

export const startCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.START_COMPANY_PAYMENT_ONLINE_BANKING,
    payload: data,
})
export const successCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.SUCCESS_COMPANY_PAYMENT_ONLINE_BANKING,
    payload: data,
})
export const finishCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.FINISH_COMPANY_PAYMENT_ONLINE_BANKING,
    payload: data,
})
export const failureCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.FAILURE_COMPANY_PAYMENT_ONLINE_BANKING,
    payload: data,
})

/*******************  3D Secure Online Bank Payment ********************* */

export const start3dSecureCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.START_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT,
    payload: data,
})
export const success3dSecureCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.SUCCESS_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT,
    payload: data,
})
export const finish3dSecureCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.FINISH_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT,
    payload: data,
})
export const failure3dSecureCompanyPaymentByOnlineBanking = data => ({
    type: LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT,
    payload: data,
})

/*******************  Transliterator Transfer Reference ********************* */

export const startTransliterationTransferReference = data => ({
    type: LedgerActionTypes.START_TRANSLITERATION_TRANSFER_REFERENCE,
    payload: data,
})
export const successTransliterationTransferReference = data => ({
    type: LedgerActionTypes.SUCCESS_TRANSLITERATION_TRANSFER_REFERENCE,
    payload: data,
})
export const finishTransliterationTransferReference = data => ({
    type: LedgerActionTypes.FINISH_TRANSLITERATION_TRANSFER_REFERENCE,
    payload: data,
})
export const failureTransliterationTransferReference = data => ({
    type: LedgerActionTypes.FAILURE_TRANSLITERATION_TRANSFER_REFERENCE,
    payload: data,
})
